import { makeAutoObservable } from "mobx";
import { ICompareValueStore } from "./compare-value-factory";
import CustomerStateCompareValueField from "../../components/policy-editor/policy-eligibility-card/condition-group-card/condition-builder/condition-field/compare-value-type-fields/customer-state-compare-value-field";
import { ICompareValueItem, IConditionFieldPreset } from "../../policy-types";
import { IStringCompareValue } from "./purchased-compare-value-store";

class CustomerStateCompareValueStore implements ICompareValueStore<string> {
    private _model: IStringCompareValue = {} as IStringCompareValue;
    private _changes: Partial<IStringCompareValue> = {};
    private _uncommittedChanges: Partial<IStringCompareValue> = {};

    constructor(private _fieldPreset: IConditionFieldPreset, compareValue?: string) {
        makeAutoObservable(this);
        if (compareValue) {
            this._model = { value: compareValue };
        }
    }

    public onOperatorChanged(): void {
    }

    public setChanges(changes?: string) {
        if (changes) {
            this._changes = { value: changes };
        }
    }

    get Component() {
        return CustomerStateCompareValueField;
    }

    get options() {
        return this._fieldPreset.compare_value_data.map(v => {
            return {
                value: (v as ICompareValueItem).value,
                label: (v as ICompareValueItem).name
            }
        });
    }

    public get value() {
        return this._uncommittedChanges.value ?? this._changes.value ?? this._model.value;
    }

    public setValue(v: string) {
        this._uncommittedChanges.value = v;
    }

    public commitChanges(): void {
        this._changes = {...this._changes, ...this._uncommittedChanges};
        this._clearUnneededChanges();
    }

    public discardUncommittedChanges(): void {
        this._uncommittedChanges = {};
    }

    public hasChanges(): boolean {
        return !!Object.values(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {};
    }

    public getUpdatedModel(): string|undefined {
        const updated = { ...this._model, ...this._changes };
        return updated.value;
    }

    public getUncommittedChanges() {
        return { ...this._model, ...this._changes, ...this._uncommittedChanges }?.value;
    }

    private _clearUnneededChanges() {
        Object.keys(this._changes).forEach(key => {
            const theKey = key as keyof IStringCompareValue;
            if (this._changes[theKey] === this._model?.[theKey]) {
                delete this._changes[theKey];
            }
        });
    }
}

export default CustomerStateCompareValueStore;
